const globalVariables = {
  api_url: 'https://jeevakarunyanidhitrust.org/index.php',
  img_url: 'https://jeevakarunyanidhitrust.org',
  backend_url: 'https://jeevakarunyanidhitrust.org',
  logo_url: 'https://jeevakarunyanidhitrust.org/logo/logo.jpeg',
  myparish_api: 'https://myparish.archeparchybookkeeping.org/index.php',
};

export default globalVariables;